import { Link, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useContext, useState } from "react";
import React from "react";
import { DataHandlerContext } from "../providers/DataHandlerProvider";
import { DataContext } from "../providers/DataProvider";

// Components
import DeleteModal from "./modal/DeleteModal";
import AddFileModal from "./modal/AddFileModal";
import EventsBottomCardButtons from "./buttons/EventsBottomCardButtons";
import ShowMoreModal from "./modal/ShowMoreModal";
import EmbbedFormButton from "./buttons/EmbbedFormButton";
import ExportCSVButton from "./buttons/ExportCSVButton";

function DisplayRecordsCard(props) {
  const {
    
    type,
    event_title,
    listOfUserSubmissions,
    totalAttendees,
    show_on_form,
    // Event
    eachEventSerieData,
    eventId,
    eventSeriesId,
    eventDate,
    googleCalendarId,
    maximumParticipants,
    notes,
    targetParticipants,
    allEvents,
    setAllEvents,
    setListOfUserSubmissions,
    
    // MarkForm
    formId,
    setMarkFormSubmissions,
  } = props;

  
  const {
    handleSubmitEventSeriesEdit,
    errorSubmit,
    loadingSubmit,
    handleDeleteSubmission,
    handleDeleteEvent,
    handleDeleteMarkFormSubmission,
  } = useContext(DataHandlerContext);

  const location = useLocation();


  const [showDeleteSubModal, setShowDeleteSubModal] = useState(false);
  const [showDeleteEventModal, setShowDeleteEventModal] = useState(false);
  const [showCSVModal, setShowCSVModal] = useState(false);
  const [deletingId, setDeletingId] = useState(null);
  const [csvEventId, setCsvEventId] = useState(null);
  const [showMoreModal, setShowMoreModal] = useState(false);
  const [showMoreModalData, setShowMoreModalData] = useState(null);

  // Handler Functions
  const handleDeleteSubData = (value, subId) => {
    setShowDeleteSubModal(value);
    setDeletingId(subId);
  };

  const handleDeleteEventData = (value, eventId) => {
    setShowDeleteEventModal(value);
    setDeletingId(eventId);
  };

  const handleCSVModal = (value, eventId) => {
    setShowCSVModal(value);
    setCsvEventId(eventId);
  };

  const handleShowMorePopUp = (data) => {
    setShowMoreModalData(data);
    setShowMoreModal(true);
  };

  // Deletion Handlers
  const handleDeleteEachSubmissionEach = async (confirmDelete, options) => {
    options.setShowModal(false);

    if (!confirmDelete) return;

    try {
      const response = await options.handleDelete(...options.deleteParams);
      console.log("Response:", response);

      if (response.status === 200) {
        options.updateState((prevState) => options.stateUpdateLogic(prevState));
      }
    } catch (error) {
      console.log("Error:", error);
    }
  };

  const deleteEventSeriesSubmissions = async (confirmDelete) => {
    console.log(
      "Delete Event Series Submissions:",
      setListOfUserSubmissions,
      listOfUserSubmissions
    );
    handleDeleteEachSubmissionEach(confirmDelete, {
      setShowModal: setShowDeleteSubModal,
      handleDelete: handleDeleteSubmission,
      deleteParams: [eventSeriesId, eventId, deletingId],
      updateState: setListOfUserSubmissions,
      stateUpdateLogic: (prevState) => ({
        ...prevState,
        [eventId]: prevState[eventId].filter((sub) => sub.id !== deletingId),
      }),
    });
  };

  const handleDeleteEachMarkSubmission = async (confirmDelete) => {
    console.log(
      "Delete Mark Form Submissions:",
      setMarkFormSubmissions,
      listOfUserSubmissions
    );

    handleDeleteEachSubmissionEach(confirmDelete, {
      setShowModal: setShowDeleteSubModal,
      handleDelete: handleDeleteMarkFormSubmission,
      deleteParams: [formId, deletingId],
      updateState: setMarkFormSubmissions,
      stateUpdateLogic: (prevState) => ({
        ...prevState,
        [formId]: prevState[formId].filter((sub) => sub.id !== deletingId),
      }),
    });
  };

  const handleDeleteEachEvent = async (confirmDelete) => {
    setShowDeleteEventModal(false);

    if (confirmDelete) {
      try {
        const response = await handleDeleteEvent(eventSeriesId, deletingId);
        console.log("Response:", response);

        if (response.status === 200) {
          setAllEvents((prevState) => ({
            ...prevState,
            events:
              prevState.events?.filter((event) => event.id !== deletingId) ||
              [],
          }));
        }
      } catch (error) {
        console.log("Error:", error);
      }
    }
  };

  // Render Helper Functions
  const getSortedSubmissions = () => {
    return listOfUserSubmissions
      ?.sort((a, b) => {
        if (a.submitted_at && b.submitted_at) {
          const dateA = new Date(a.submitted_at);
          const dateB = new Date(b.submitted_at);
          return dateB - dateA;
        }

        if (a.submitted_at) return -1;
        if (b.submitted_at) return 1;

        //Sort by alphabetical order if both dates are null
        return a.first_name.localeCompare(b.first_name);
      });
  };

  // Render header buttons based on card type
  const renderHeaderButtons = () => {
    if (type === "markform") {
      return (
        <div className="flex gap-4">
          <EmbbedFormButton name={event_title} id={formId} />
          <ExportCSVButton
            data={listOfUserSubmissions}
            fileName={`${event_title} - ${formId} - ${new Date().toLocaleDateString()}`}
          />
        </div>
      );
    }

    return (
      <div className="flex gap-4">
        <button
          onClick={() => {
            handleDeleteEventData(true, eventId);
          }}
          className="rounded-lg text-md hover:shadow-lg px-4 py-2 bg-red-300 text-red-700 flex gap-1 items-center"
        >
          Delete
        </button>

        <button
          onClick={() => {
            handleCSVModal(true, eventId);
          }}
          className="rounded-lg text-md hover:shadow-lg px-4 py-2 bg-gray-300 text-red-700 flex gap-1 items-center"
        >
          <svg
            className="w-6 h-6 text-gray-800 dark:text-white"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 20 16"
          >
            <path
              stroke="currentColor"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M8 8v1h4V8m4 7H4a1 1 0 0 1-1-1V5h14v9a1 1 0 0 1-1 1ZM2 1h16a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1Z"
            />
          </svg>
        </button>
      </div>
    );
  };

  // Render table rows for submissions
  const renderSubmissionRow = (submission, key) => {
    return (
      <tr
        key={submission.id}
        className={key % 2 === 0 ? "bg-slate-100" : ""}
      >
        <td className="px-2 py-2">
          {submission.first_name} {submission.last_name}
        </td>
        <td className="px-2 py-2">{submission.job_title}</td>
        <td className="px-2 py-2">{submission.organisation}</td>
        <td className="px-2 py-2 text-center">
          <a
            href={`mailto:${submission.email}`}
            className="text-blue-500"
          >
            Send
          </a>
        </td>
        <td className="w-2 py-2 px-2 items-center m-2 text-center">
          <button
            onClick={() => {
              console.log("Delete Submission:", submission.id);
              handleDeleteSubData(true, submission.id);
            }}
            className="p-1 rounded-md bg-red-200 hover:bg-red-300"
          >
            <svg
              className="h-8 w-8 text-red-500"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
            >
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </td>
        <td className="w-2 py-2 px-2 items-center m-2 text-center">
          <button
            onClick={() => handleShowMorePopUp(submission)}
            className="p-1 rounded-md bg-blue-200 hover:bg-blue-300"
          >
            <svg
              className="w-8 h-8 text-gray-800 dark:text-white"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m9 5 7 7-7 7"
              />
            </svg>
          </button>
          {}
        </td>
      </tr>
    );
  };

  // Render mobile card for a submission
  const renderMobileSubmissionCard = (submission, key) => {
    return (
      <div
        key={submission.id}
        className={`p-4 mb-4 rounded-lg border border-slate-200 ${
          key % 2 === 0 ? "bg-slate-100" : "bg-white"
        }`}
      >
        <div className="flex justify-between items-start mb-2">
          <div>
            <h3 className="font-bold text-lg">
              {submission.first_name} {submission.last_name}
            </h3>
            <p className="text-sm text-slate-600">
              {submission.job_title}
            </p>
          </div>
          <div className="flex space-x-2">
            <button
              onClick={() => {
                console.log("Delete Submission:", submission.id);
                handleDeleteSubData(true, submission.id);
              }}
              className="p-1 rounded-md bg-red-200 hover:bg-red-300"
            >
              <svg
                className="h-6 w-6 text-red-500"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
              >
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
            <button
              onClick={() => handleShowMorePopUp(submission)}
              className="p-1 rounded-md bg-blue-200 hover:bg-blue-300"
            >
              <svg
                className="w-6 h-6 text-gray-800 dark:text-white"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m9 5 7 7-7 7"
                />
              </svg>
            </button>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-2 text-sm">
          <div>
            <span className="font-medium text-slate-700">
              Organisation:
            </span>
          </div>
          <div>{submission.organisation}</div>

          <div>
            <span className="font-medium text-slate-700">Email:</span>
          </div>
          <div>
            <a
              href={`mailto:${submission.email}`}
              className="text-blue-500"
            >
              Send Email
            </a>
          </div>
        </div>
      </div>
    );
  };


 
    

  // Main Render

  return (<>
   
    <div className={`${type=== "event" ? show_on_form  ? "bg-white": " opacity-70" : "bg-white"} mb-10 p-6 w-full flex flex-col justify-between rounded-sm shadow-sm`}>
      {/* Card Header */}
      

      {!show_on_form && type === "event" && (        
          <p className="text-1xl text-red-800 text-center">This event is disabled on the form</p>
)}
      <div className="flex justify-between items-center py-2">
      
        <p className="text-2xl">{event_title}</p>
        {renderHeaderButtons()}
      </div>

      {/* Card Stats */}
      <div className="flex justify-between mb-4">
        <div className="flex flex-col justify-between">
          <p className="font-bold">
            {type === "event" ? "Total Signups" : "Total"}
          </p>
          <span className="font-extrabold text-3xl text-orange-500">
            {totalAttendees}
          </span>
        </div>
      </div>

      

      

      {/* Submissions Table/List */}
      <div className="overflow-x-auto">
        <div className="hidden md:block">
          <table className="w-full table-auto mb-4">
            <thead>
              <tr className="bg-slate-200">
                <th className="px-2 py-2 text-left">Name</th>
                <th className="px-2 py-2 text-left">Job Title</th>
                <th className="px-2 py-2 text-left">Organisation</th>
                <th className="px-2 py-2">Email</th>
                <th className="px-2 py-2">Action</th>
                <th className="px-2 py-2">More</th>
              </tr>
            </thead>
            <tbody>
              {getSortedSubmissions()?.map((submission, key) => 
                renderSubmissionRow(submission, key)
              )}
            </tbody>
          </table>
        </div>

        {/* Mobile View */}
        <div className="md:hidden">
          {getSortedSubmissions()?.map((submission, key) => 
            renderMobileSubmissionCard(submission, key)
          )}
        </div>
      </div>

      {/* Modals */}
      {showDeleteSubModal && (
        <DeleteModal
          text={"Are you sure you want to delete this submission?"}
          funct={
            type === "markform"
              ? handleDeleteEachMarkSubmission
              : deleteEventSeriesSubmissions
          }
        />
      )}
      
      
     
      {type === "event" && (
        <EventsBottomCardButtons
          eventId={eventId}
          eventSeriesId={eventSeriesId}
          listOfUserSubmissions={listOfUserSubmissions}
          googleCalendarId={googleCalendarId}
          event_title={event_title}
          event_series_title={eachEventSerieData.title}
          
        />
      )}
    </div>
    {/* Delete Event Modal */}
    {showDeleteEventModal && (
        <DeleteModal
          text={"Are you sure you want to delete this event?"}
          funct={handleDeleteEachEvent}
        />
      )}
    {/* CSV Upload Modal */}
    {showCSVModal && (
      <AddFileModal
        text={"Upload CSV file"}
        eventId={csvEventId}
        eventSeriesId={eventSeriesId}
        setModal={setShowCSVModal}
        setListOfUserSubmissions={setListOfUserSubmissions}
        listOfUserSubmissions={listOfUserSubmissions}
        event_title={event_title}
      />
    )}
    {showMoreModal && (
        <ShowMoreModal
          submission={showMoreModalData}
          setShowMoreModal={setShowMoreModal}
        />
      )}
    </>);
}

export default DisplayRecordsCard;